import React, { useRef, useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { setLocale } from 'yup';
import { SuccessMessage, ErrorMessage } from '../../../../extras/toastMessages';
import clienteAxios from '../../../../../config/axios';
import { MSG_REJECT_SUCCESS } from '../../../../../constants/messages';
import { ICON_SAVE, ICON_CANCEL } from '../../../../extras/icons';
import ButtonSpinner from '../../../../layout/ButtonSpinner'

//Axios
import { useDispatch, useSelector } from 'react-redux';
import { rejectAudiencesAction } from '../../../../../actions/audiencesActions';
import { MOTIVO_RECHAZO } from '../../../../../data/motivesGroups';

//Función principal
const RejectForm = props => {
    //Tomo los props
    const { show, handleClose, audience } = props;
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Genero los ref
    const refMotive = useRef();
    //Inicializo datos
    const initialData = {
        motivo: '',
        observacion: ''
    }
    //Inicializo el state local
    const [motives, setMotives] = useState([]);
    //Traigo el store
    const loading = useSelector(state => state.audiences.audienceLoading);
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Cargo los motivos
        loadMotives();
        //Pongo el foco en el primer campo
        refMotive.current.focus();
    }
    //Manejo el guardado
    const handleSave = async values => {
        //Genero la data
        const data = {
            audienciaId: audience.id,
            motivoId: values.motivo,
            observacionRechazo: values.observacion
        }
        //Llamo al dispatch
        dispatch( rejectAudiencesAction(audience, data) );
    }
    //Función que cargar los motivos
    const loadMotives = async () => {
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/motivo?search=activo:1`);
            //Obtengo los datos
            const audienceMotives = response.data;
            //Llamo al dispatch
            setMotives(audienceMotives.content);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
    //Esquema de validación
    const validationSchema = yup.object({
        motivo: yup.number().required(),
        observacion: yup.string().required(),
    });
    //Renderizo
    return (
        <Modal
            show={show} 
            onHide={handleClose} 
            onShow={handleOnShow} 
            aria-labelledby="contained-modal-title-vcenter" 
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Rechazar Solicitud #{ audience.id }
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...initialData }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <div className="col-12">
                                    <div className="alert alert-info">
                                        Seleccione el <strong>Motivo</strong> e ingrese una <strong>observación</strong>
                                    </div>
                                </div>
                                <Form.Group className="col-md-12">
                                    <Form.Control
                                        as="select"
                                        id="motivo"
                                        className="form-control"  
                                        name="motivo" 
                                        type="text" 
                                        value={ values.motivo }
                                        onChange={handleChange}
                                        ref={refMotive}
                                        isInvalid={!!errors.motivo}
                                        disabled={ loading }
                                    >
                                        <option value="">Motivo...</option>
                                        {
                                            motives.filter(m => m.grupoId === MOTIVO_RECHAZO).map(motive => (
                                                <option value={ motive.id } key={`rfm${motive.id}`}>
                                                    { motive.descripcion }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.motivo }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <Form.Control
                                        id="observacion"
                                        className="form-control" 
                                        autoFocus 
                                        name="observacion" 
                                        type="text" 
                                        placeholder="Ingrese observación"
                                        value={ values.observacion }
                                        onChange={handleChange}
                                        isInvalid={!!errors.observacion}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.observacion }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                loading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="danger" type="submit" disabled={ loading }>
                                        <ICON_SAVE /> <strong>RECHAZAR</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleClose} disabled={ loading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default RejectForm;